<script>
import { hasAdminRole } from '@/api/Utilities.js'
import { getMyUserId } from '@/api/FirebaseUserWrapper.js'

// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
const analytics = getAnalytics(firebaseApp)
require('@/css/style.css')
export default {
  components: {},
  data () {
    return {
      userId: ''
    }
  },
  async created () {
    this.userId = await getMyUserId()
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'aboutNode/aboutNode')
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.about {
  margin: auto;
  max-width: 1024px;
  padding: 1.0rem;
}
.is-rounded {
  border: 1px solid #999999;
  border-radius: 10px;
}
.subfooter {
  background-color: #191970;
  color: #fff;
  width: auto;
  padding: 3rem 1.5rem 6rem
}
</style>
<template>
  <div class="about">
    <div class="tabs is-left is-small">
      <ul>
        <li>
          <router-link to="/about">概要</router-link>
        </li>
        <li>
          <router-link to="/about/team">チームについて</router-link>
        </li>
        <li>
          <router-link to="/about/tree">ツリーについて</router-link>
        </li>
        <li class="is-active">
          <router-link to="/about/node">ふせんについて</router-link>
        </li>
      </ul>
    </div>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">ふせんの追加</p>
        <p class='text'>
          ふせんを選択して、「+ボタン」または「エンターキー」を押すことで次のふせんに書き込むことができます。<br>
          テキストエリアに記入して、「ポストボタン」または「コントロール＋エンターキー」を押すことで投稿できます。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/node_post.png">
      </div>
    </div>
    <hr>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">メンション</p>
        <p class='text'>
          テキストエリアに@マークを記入することで、チームメンバーにメンション通知することができます。<br>
          自分のブランチで仲間に依頼や質問をする際に便利です。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/node_mention.png">
      </div>
    </div>
    <hr>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">色の変更</p>
        <p class='text'>
          パレットボタンを選択して色を変更することができます。<br>
          重要な案件やToDoアイテムを色を変更して管理することができます。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/node_color.png">
      </div>
    </div>
    <br>
    <div class="subfooter">
      <div class="content has-text-centered is-size-7">
        <div class="columns is-multiline is-mobile">
          <div class="column is-half">
            <router-link to="teams" class="has-text-white">
              <p>開発チーム</p>
            </router-link>
          </div>
          <div class="column">
            <router-link to="terms" class="has-text-white">
              <p>利用規約</p>
            </router-link>
          </div>
        </div>
        <div class="columns is-multiline is-mobile">
          <div class="column is-half">
            <router-link to="privacy" class="has-text-white">
              <p>プライバシー</p>
            </router-link>
          </div>
          <div class="column">
            <router-link to="contact" class="has-text-white">
              <p>お問合せ</p>
            </router-link>
          </div>
        </div>
        <p>@socialup</p>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/about/tutorial/AboutNode.vue